export default {
    hasura: {
        uri: 'https://hasura-dev.dressdio.me/v1/graphql',
    },
    api: {
        // uri: `http://localhost:8000`,
        uri: 'https://api-dev.dressdio.me',
        cdnUrl: 'https://cdn.dressdio.me/dressdio',
        fsUri: `https://fs.dressdio.me`,
    },
    social: {
        google: {
            clientId: '804473356054-7gi3pg0l3o9dr8nd1l03e0lv7ujhlc66.apps.googleusercontent.com',
        },
    },
};
